import { asNullableText } from '@/entities/admin/model/mapPrimitives'

export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

export function mapUtm(raw) {
  if (!raw || typeof raw !== 'object') {
    return null
  }

  const utm = {}
  let hasValue = false
  for (const key of UTM_KEYS) {
    const value = asNullableText(raw[key])
    utm[key] = value
    if (value) {
      hasValue = true
    }
  }
  return hasValue ? utm : null
}

export function formatUtmField(utm, key, empty = '—') {
  const value = String(utm?.[key] ?? '').trim()
  return value || empty
}
